import {
  Container,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, { ReactElement } from "react";
import GraphGrid from "./graph";
import MessstellenAuswahlGrid from "./MessstellenAuswahl";

export default function Datenvollstaendigkeit(): ReactElement {

  return (
    <Container maxWidth={false} style={{ marginTop: "10px" }}>
      <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
        <Grid item md={3} />
        <Grid item md={6}>
          <Typography color="primary" variant="h5">
            Datenvollständigkeit
          </Typography>
        </Grid>
      </Grid>
      <div>
        <MessstellenAuswahlGrid />
        <GraphGrid />
      </div>
    </Container >
  );
}